import { CSSProperties, FC, PropsWithChildren, ReactNode } from 'react';

import * as TooltipPrimitive from '@radix-ui/react-tooltip';

import { TOOLTIP_TEST_IDS } from '@/constants/data-testids';
import { cn } from '@/utils/tailwind';

type TooltipProps = PropsWithChildren<{
  bodyClassName?: string;
  triggerAriaLabel?: string;
  triggerStyle?: CSSProperties;
  triggerTestId?: string;
  triggerClassName?: string;
  title?: string | ReactNode;
}>;

const Tooltip: FC<TooltipProps> = ({
  bodyClassName,
  children,
  title,
  triggerAriaLabel,
  triggerClassName,
  triggerStyle,
  triggerTestId = TOOLTIP_TEST_IDS.TRIGGER,
}) => {
  return (
    <TooltipPrimitive.Provider delayDuration={0}>
      <TooltipPrimitive.Root>
        <TooltipPrimitive.Trigger data-testid={triggerTestId} asChild>
          <span
            aria-label={triggerAriaLabel}
            className={cn(
              'cursor-pointer text-body-12-regular !text-custom-warm-grey-500',
              triggerClassName
            )}
            style={triggerStyle}
          >
            {children}
          </span>
        </TooltipPrimitive.Trigger>

        {title && (
          <TooltipPrimitive.Content
            data-testid={TOOLTIP_TEST_IDS.CONTENT}
            sideOffset={8}
            collisionPadding={8}
            className="relative z-50 block max-w-[280px] rounded-[8px] bg-custom-warm-grey-25 shadow-lg"
          >
            <div
              className={cn(
                'p-3 block text-body-14-regular !text-center !text-custom-warm-grey-700',
                bodyClassName
              )}
            >
              {title}
            </div>
            <TooltipPrimitive.Arrow width={12} height={7} className="fill-custom-warm-grey-25" />
          </TooltipPrimitive.Content>
        )}
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  );
};

export { Tooltip };
